import { useThemeMode } from '../contexts/ThemeContext';
import { IMG } from '../theme/assets';

/**
 * グループ共有まわりのアイコンを、テーマに合った版で返す。
 *
 * 藍（#1d4e89）はダイアログのタイルが暗くなる暗いテーマだと地との差が 1.9:1 しか
 * 残らず、色の面がほぼ消える。明度を上げた版（#6ea8e8 / #f58368）に差し替えると
 * 6.2〜6.3:1 になるので、テーマごとにファイルを分けている。
 */
export const useShareIcons = () => {
  const { themeMode } = useThemeMode();
  const dark = themeMode === 'dark';
  return {
    stepGroup: dark ? IMG.share.stepGroupDark : IMG.share.stepGroup,
    stepInvite: dark ? IMG.share.stepInviteDark : IMG.share.stepInvite,
    stepProject: dark ? IMG.share.stepProjectDark : IMG.share.stepProject,
    itemKind: dark ? IMG.share.itemKindDark : IMG.share.itemKind,
    folders: dark ? IMG.workspace.foldersDark : IMG.workspace.folders,
  } as const;
};

export default useShareIcons;
